/* this file is transformed by vux-loader */
/* eslint-disable */
/* this file is transformed by vux-loader */

/* eslint-disable */

/*
 * @Description:
 * @Author: 王佳兴
 * @Github:
 * @Date: 2019-01-15 19:30:59
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-07-06 16:45:36
 */

/*
 * vux 插件初始化 并且自定义
 *
 * */
import Vue from 'vue'; // import {
//   WechatPlugin,
//   AjaxPlugin,
//   ToastPlugin,
//   AlertPlugin,
//   dateFormat
// } from 'vux'

import WechatPlugin from 'vux/src/plugins/wechat';
import AjaxPlugin from 'vux/src/plugins/ajax';
import ToastPlugin from 'vux/src/plugins/toast';
import AlertPlugin from 'vux/src/plugins/alert';
import store from '@/store/index';
import qs from 'qs'; // axios将JS对象序列化为JSON 需要QS重新编码

Vue.use(AjaxPlugin); //Vue.http

Vue.use(WechatPlugin); //Vue.wechat

Vue.use(ToastPlugin);
Vue.use(AlertPlugin);
Vue.http.defaults.timeout = 10000;
export default (function () {
  //发起拦截器
  // Vue.http.defaults.withCredentials=true;
  Vue.http.interceptors.request.use(function (config) {
    if (config.method == 'get') {} else {
      Vue.http.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'; // 暂时使用

      var sessionUserInfo = sessionStorage.wxUserInfo;
      var userInfo = null;

      if (sessionUserInfo) {
        try {
          userInfo = JSON.parse(sessionUserInfo);
        } catch (e) {}
      }

      var params = config.data;

      if (params && userInfo && userInfo.id && userInfo.wxOpenId) {
        params.userId = userInfo.id;
        params.wxOpenId = userInfo.wxOpenId;
      } // end


      config.data = qs.stringify(params);
    }

    return config;
  }, function (error) {
    return Promise.reject(error);
  }); //响应拦截器

  Vue.http.interceptors.response.use(function (response) {
    var resp = response.data;

    if (/indexList|doList/.test(response.request.responseURL ? response.request.responseURL : response.config.url)) {
      store.dispatch('loadingCoverAction', 0);
    }

    if (resp.status == 1 || resp.code == 1) {
      console.log('-');
    } else {
      Vue.$vux.toast.show({
        text: resp.message || '接口错误',
        position: 'middle',
        type: 'text',
        width: '6rem'
      });
      return Promise.reject(resp);
    }

    return response;
  }, function (error) {
    if (error.message == '请求取消') {
      console.log(error, '------------');
    } else {
      Vue.$vux.toast.show({
        text: '请您检查网络',
        position: 'top',
        type: 'text',
        width: '5rem'
      });
    }

    return Promise.reject(error);
  });
});